import React from "react";
import { ChevronRight } from "lucide-react";
import { SITE_PUBLIC_URL } from "./usePageMeta";

// Breadcrumb trail UI. items: [{ label, href }] — last item is the current page (no link).
export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-sm">
    <ol className="flex flex-wrap items-center gap-1.5 text-[#173042]/55">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <li key={it.label} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={13} className="text-[#173042]/35" />}
            {last ? (
              <span aria-current="page" className="font-semibold text-[#133955]">{it.label}</span>
            ) : (
              <a href={it.href} className="hover:text-[#54BCE6] transition-colors" data-testid={`breadcrumb-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{it.label}</a>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export const breadcrumbJsonLd = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.label,
    ...(it.href ? { item: `${SITE_PUBLIC_URL}${it.href}` } : {}),
  })),
});
